<template>
    <div>
        <p style="font-weight:bold">See how ProofreadingPal's <a href="two-proofreader-model.php">two-proofreader model</a> can improve your writing! ProofreadingPal will provide a free sample on up to 400 words. Order your free sample proofread below and get your results via email within {{ SelectedData.turnaround.text }}.</p>
        <div class="formBlock formBlockDouble">
            <div class="formRow container">
                <div class="col col-2">
                    <label class="formLabel">*First Name</label>
                    <input type="text" placeholder="*First Name" class="formText" 
                    v-model="SelectedDataChild.firstName"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
                <div class="col col-2">
                    <label class="formLabel">*Last Name</label>
                    <input type="text" placeholder="*Last Name" class="formText" 
                    v-model="SelectedDataChild.lastName"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
                
            </div>

            <div class="formRow container">
                <div class="col col-2" style="margin-bottom:0;">
                    <label class="formLabel">*Email</label>
                    <input type="text" placeholder="*Email" class="formText"
                    v-model="SelectedDataChild.email"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                    <div class="step3RightTxtNote" style="margin-bottom:10px;">Please ensure you are entering a real email address. <br>Your free sample will be emailed to the email address you enter above.</div>
                </div>
                <div class="col col-2" style="margin-bottom:0;">
                    <label class="formLabel">*Confirm Email</label>
                    <input type="text" placeholder="*Confirm Email" class="formText" 
                    v-model="SelectedDataChild.confirmEmail"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
            </div>

            <div class="formRow container">
                <div class="col col-2">
                    <label class="formLabel">Organization</label>
                    <input type="text" placeholder="Organization" class="formText" 
                    v-model="SelectedDataChild.organization"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
                <div class="col col-2">
                    <label class="formLabel">Which option best describes you?</label>
                    <select class="formSelect" 
                    v-model="SelectedDataChild.describeOption"
                    @change="$emit('updateSampleData', SelectedDataChild)">
                        <option value="">*Select Option</option>
                        <option value="me_academic">A university academic (e.g., student, professor)</option>
                        <option value="me_author">An author (non-academic)</option>
                        <option value="me_business">A businessperson</option>
                        <option value="me_seeking_job">Applying for a new job (e.g., seeking resume help)</option>
                        <option value="me_other">None of these options describe me</option>
                    </select>
                </div>
                
            </div>

            <div class="formRow container">
                <p>Please attach your entire document file. Our two proofreaders will randomly choose a 400-word section within your document to complete your free sample.
                    If your document is fewer than 400 words, ProofreadingPal will provide a free sample on your entire document.
                </p>
                <div class="blueFormRow">
                    <div class="col col-2">
                        <CheckoutUpload
                            @fileUploaded="
                                (SelectedDataChild.fileUploaded = $event),
                                $emit('updateSampleData', SelectedDataChild)
                            "
                            :fileUploaded="SelectedData.fileUploaded"
                        />
                    </div>
                    <div class="col col-2">
                        <label class="formLabel">English Type</label>
                        <select
                            class="formSelect"
                            v-model="SelectedDataChild.englishType"
                            @change="$emit('updateSampleData', SelectedDataChild)"
                        >
                            <option value="">Select English Type</option>
                            <option value="US English">US English</option>
                            <option value="Canadian English">Canadian English</option>
                            <option value="UK English">UK English</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="formRow container">
                <div class="col col_2_of_2">
                    <CheckoutWritingStyle
                        @updateWritingStyle="
                            (SelectedDataChild.selectedWritingStyle = $event),
                                $emit('updateSampleData', SelectedDataChild)
                        "
                        :selectedWritingStyle="SelectedData.selectedWritingStyle"
                    />
                </div>
                
            </div>

            <div class="formRow container">
                <div class="col col_2_of_2">
                    <label class="formLabel">Do you have any special preferences? (Optional)</label>
                    <textarea class="formTextarea" 
                        v-model="SelectedDataChild.message"
                        @input="$emit('updateSampleData', SelectedDataChild)"
                    ></textarea>
                </div>
            </div> 
            <div class="formRow container" v-if="!SelectedData.emailSent && !recaptchaDisable">
                <div class="col col_2_of_2">
                    <vue-recaptcha sitekey="6LeuCBATAAAAANWR4slBd8akYHCW6kQXzSGzFv4n" 
                    :loadRecaptchaScript="false"
                    @verify="verifyRecaptcha($event)"
                    ></vue-recaptcha>
                    
                </div>
                
            </div>
            <transition name="fade">
            <div v-if="SelectedData.sendingMail">
                <img
                    :src="siteUrl + 'imgs/indicator.gif'"
                    alt=""
                    width="42"
                    height="28"
                />
            </div>
            </transition>

            <div v-if="SelectedData.emailSent">
                <div class="formRow container">
                    <div class="col col_2_of_2" style="margin-bottom:0;">
                        <div class="validation1" style="display:block;">
                            <p>An email validation code was just emailed to the email address you entered above. Please type in the validation code you received in our email in the field below to proceed with your free sample order. <strong>Please be sure to double check your spam, junk, clutter, or updates folder in your email.</strong></p>
                        </div>
                    </div>
                </div> 
                <div class="formRow container">
                    <div class="col col-2">
                        <input type="text" placeholder="*Email Validation Code" class="formText" 
                        v-model="SelectedDataChild.code"
                        @input="$emit('updateSampleData', SelectedDataChild)"
                         />
                        <input type="hidden" name="valsent" id="valsent" value="" />
                    </div>
                    <div class="col col-2">
                        <a href="javascript:void(0)" 
                        @click="$emit('resendEmailCode')"
                        style="display:block;padding-top:10px;">Resend Validation Code</a>
                        <div id="emailMessage" class="step3RightTxtNote" v-if="SelectedDataChild.resent">Your email validation code has been re-sent.</div>
                    </div>
                    
                </div>
            </div>
            <div class="formRow container">
                <div class="col">
                    <input type="submit" 
                    :value="SelectedData.emailSent ? 'Verify Email' : 'Get Your Free Sample'" 
                    class="button button-blue" 
                    @click="$emit('moveToStep', [1,2])" />
                    <div class="trustedsite-trustmark" style="vertical-align:middle;" data-type="211" data-width="120" data-height="50"></div>
                    <!-- End McAfee SECURE Engagement Trustmark for proofreadingpal.com -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckoutUpload from '@/components/CheckoutUpload.vue';
import CheckoutWritingStyle from '@/components/CheckoutWritingStyle.vue';
import VueRecaptcha from 'vue-recaptcha';
export default {
    components: {
        CheckoutUpload,
        CheckoutWritingStyle,
        VueRecaptcha,
    },
    props: {
        SelectedData: Object,
        recaptchaDisable: Boolean,
    },
    data() {
        return {
            SelectedDataChild: this.SelectedData,
            recaptcha: false,
        };
    },
    mounted: function() {
        this.$nextTick(function() {
            this.$emit('loaded', true);
        });
    },
    methods: {
        verifyRecaptcha(response) {
            this.SelectedDataChild.recaptchaResponse = response;
            this.$emit('updateCheckoutData', this.SelectedDataChild);
        }
    }
}
</script>

<style>
#emailMessage {
    color: green;
}
</style>